import React from 'react'
import { Spinner } from 'reactstrap'
import { withTranslation } from "react-i18next";


const CardGameLoader = (props) => {
    return (
        <div className="loading-bt">
            <Spinner className="game-card-loader" animation="border" size="sm" />
        </div>
    )
}

export default withTranslation()(CardGameLoader);

